<template>
        <div :class="['page unsub',{ off: !pageOn }]">
            <VHeader type="back" @back="pageOn = false;" />
            <div class="page-content">
                <img class="page-image" src="/unsub.png" />
                <div class="div-btns" :style="{ position: 'absolute', top: '0px', left: '0px' }">
                    <p @click="$emit('unsub',false),pageOn = false" style="position: absolute;top:255px;left:20px;width: 340px;height: 70px;background-color: rgba(200,0,0,0);"></p>
                    <p @click="$emit('unsub',true),pageOn = false" style="position: absolute;top:335px;left:20px;width: 340px;height: 70px;background-color: rgba(200,0,0,0);"></p>
                </div>
                <!--
                <h1>We are sorry to see you go</h1>
                <p class="btn lg" @click="$emit('unsub',true),pageOn = false">UNSUBSCRIBE</p>
                <p class="btn lg" @click="$emit('unsub',false),pageOn = false">I WANT TO STAY</p>
                -->
            </div>  
        </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import WebSoc from '@/utils/WebSoc.js'
import { mapActions } from 'vuex';

export default {
    name: 'ubsub',
    props: ['user'],
    mixins: [ pageOn ],
    components: {
        VHeader
    },
    mounted () {
        var width = parseInt(getComputedStyle(this.$el.querySelector('.page-content')).width);
        this.$el.querySelector('.div-btns').style.transform = 'scale('+( width / 414 )+')';
    }
}

</script>

<style lang="scss">
.unsub {
    h1 {
        font-size: 20px;
        text-align: center;
        margin: 20px 0px;
    }
}
</style>